import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaCar, FaRoute, FaUserTie, FaCogs, FaHandshake, FaFileInvoiceDollar, FaMapMarkerAlt, FaCheckCircle } from "react-icons/fa";
import s2 from "../assets/images/et-services.png";
import "./EmployeeTransportationServices.css";

const EmployeeTransportationServices = () => {
  const benefits = [
    { icon: <FaCogs />, text: "Fleet Optimization" },
    { icon: <FaRoute />, text: "Routing and planning" },
    { icon: <FaCar />, text: "Fleet of vehicles to choose" },
    { icon: <FaUserTie />, text: "Experienced chauffeurs" },
    { icon: <FaCheckCircle />, text: "Customized package" },
    { icon: <FaHandshake />, text: "Tie-up with Licensed company" },
    { icon: <FaFileInvoiceDollar />, text: "Convenient billing process" },
    { icon: <FaMapMarkerAlt />, text: "All cars are equipped with GPS devices and real-time tracking" },
  ];

  return (
    <div className="ets-wrapper">
      {/* Hero Section */}
      <div className="inner-banner ets-hero-section">
        <Container>
          <Row className="align-items-center">
            <Col xs={12} md={7}>
              <div className="ets-hero-content contact-banner pt-80">
                <h4 className="ets-hero-title">EMPLOYEE TRANSPORTATION SERVICES</h4>
                <p className="ets-hero-text pr-50">
                  Hive Employee Transportation And Cab Services has emerged as the leading transport company in Telangana, Hyderabad for Employee Transportation. Since, Hyderabad is the IT hub; employees have different working hours according to the overseas clients’ time zone. This is why; companies hire us for employee transportation helping executives and other employee to travel home and office safely. Our professional chauffeurs arrive at time to pick and drop to the destination. We are currently associated with MNC/GCC
                </p>
              </div>
            </Col>
            <Col xs={12} md={5} className="pr-0">
              <div className="ets-hero-image-wrapper">
                <img src={s2} className="img-fluid ets-hero-image" alt="Employee Transportation" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Main Content Section */}
      <div className="section ets-intro-section">
        <Container>
          <Row className="mt-60 justify-content-center">
            <Col xs={12} md={10} data-aos="fade-up">
              <div className="service-cardss">
                <h6 className="ets-intro-title">WE HAVE FLEET OF VEHICLES FROM 4 SEATERS TO 42 SEATERS FOR EMPLOYEE TRANSPORTATION</h6>
                <p className="ets-intro-text">
                  We believe that every company wants to treat its employees fairly that will bring positive return in long term. Comfort and facilities are two most important parts for their happiness. By offering transportation service, companies along with us are doing their best to offer quality and safe working environment to employees. We have fleet of vehicles from 4 seaters to 42 seaters for Employee Transportation. So you can book the vehicle according to the number of employees you want to offer transfer service.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Benefits Grid Section */}
      <div className="ets-benefits-section">
        <Container>
          <div className="text-center">
            <h5 className="ets-section-subtitle">Hive Employee Transportation And Cab Services benefits</h5>
          </div>
          
          <div className="ets-benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="ets-benefit-card" data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="ets-benefit-icon">
                  {benefit.icon}
                </div>
                <h5 className="ets-benefit-text">{benefit.text}</h5>
              </div>
            ))}
          </div>

          {/* Conclusion Section */}
          <div className="ets-conclusion-section" data-aos="fade-up">
            <p className="ets-conclusion-text">
              For us, our passenger safety is really important, and so we ensure that we keep a track on our every vehicle on road. From sedan to SUV, every car in well-maintained and comply with rules and regulations. So sit back and relax to enjoy safe ride. We at Hive Employee Transportation And Cab Services have been offering employee transportation to some of the top companies in Telangana, Hyderabad. So if you want to join our clientele list then do connect with us to help your employees get professional transfer service.
            </p>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default EmployeeTransportationServices;
